import { useState } from "react";
import { MyDate, getDatefromWeekNum0, weeknum } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function WeekSelect({
    curWeekStart, 
    setWeekStart, 
    curWeekEnd, 
    setWeekEnd, 
    setCurrentPage, 
    history, 
    path1, 
    beginWeek, 
}){
    const [weeks] = useState(
        () => {
        const dateIterator = new MyDate(beginWeek);
        const dateArray = [];
        while(dateIterator < getDatefromWeekNum0(weeknum(new MyDate()), 0)){
            dateArray.push(weeknum(dateIterator));
            dateIterator.setDate(dateIterator.getDate() + 7);
        }
        if(!dateArray.includes(weeknum(new MyDate()))){
            dateArray.push(weeknum(new MyDate()));
        }
        return dateArray.reverse();
    }
    )
    return (
        <>
        <span className = "d-flex align-items-center">
        <label htmlFor = "start" className = "mb-0">Week Start:</label>
        <select id = "start" className = "form-control w-auto ml-2" value = {curWeekStart} onChange = {e => {
            history.push(`/${path1}`);
            setWeekStart(e.currentTarget.value);
            setCurrentPage(1);
        }}>
            {weeks.filter((_, weekIndex) => weeks.indexOf(curWeekEnd) <= weekIndex).map((week, weekIndex) => 
                <option key = {weekIndex}>{week}</option>
            )}
        </select>
    </span>
    <span className = "d-flex align-items-center">
        <label htmlFor = "end" className = "mb-0">Week End:</label>
        <select id = "end" className = "form-control w-auto ml-2" value = {curWeekEnd} onChange = {e => {
            history.push(`/${path1}`);
            setWeekEnd(e.currentTarget.value);
            setCurrentPage(1);
        }}>
            {weeks.filter((_, weekIndex) => weeks.indexOf(curWeekStart) >= weekIndex).map((week, weekIndex) => 
                <option key = {weekIndex}>{week}</option>
            )}
        </select>
    </span>
    </>
    )
}